type Nullish = undefined | null;

export interface Page<T> {
  items: T[];
}

export type User = {
  id: string;
  name: string;
  type: 'user';
  /** A list of IDs of groups the user is member in. */
  groups?: string[] | Nullish;
  avatar?: string | Nullish;
  phone?: string | Nullish;
  email?: string | Nullish;
  extid?: string | Nullish;
  external_id?: string | Nullish;
  custom?: {
    // will be filled with platform-specifics that don't match the above
    [name: string]: unknown;
  };
};

export type Group = {
  id: string;
  name: string;
  type: 'group';
  userCount?: number | Nullish;
  avatar?: string | Nullish;
  custom?: {
    // will be filled with platform-specifics that don't match the above
    [name: string]: unknown;
  };
};

export type Identity = User | Group;
export type IdentityTypes = 'user' | 'group';

export interface Notification {
  recipients: string[];
  content: NotificationContent;
  link?: string;
  image?: NotificationImage;
}

export interface NotificationImage {
  en: {
    href: string;
  };
  de: {
    href: string;
  };
}

export interface NotificationContent {
  en: {
    title: string;
  };
  de: {
    title: string;
  };
}

export const StoreKeyTypes = ['tenant', 'editor', 'user'] as const;
export const SetStoreKeyTypes = ['tenant', 'editor', 'user'] as const;
export type StoreKeyType = (typeof StoreKeyTypes)[number];
export type SetStoreKeyType = (typeof SetStoreKeyTypes)[number];
export type DeleteStoreKeyType = SetStoreKeyType;
export type AdminStoreKeyType = Exclude<(typeof StoreKeyTypes)[number], 'user'>;
export const StoreKeyDefault = 'default';
export const StoreSecretKeyPrefix = 's:';
export const StoreKeyOverrides = 'instanceOverrides';
export interface StoreKey {
  type: StoreKeyType;
  key: string;
  isSecret?: boolean;
}
export interface SetStoreKey extends StoreKey {
  type: SetStoreKeyType;
}
export interface StoreEntry<T> extends StoreKey {
  value: T;
}
export interface SetStoreEntry<T> extends SetStoreKey {
  value: T;
}
export interface DeleteStoreKey extends StoreKey {
  type: DeleteStoreKeyType;
}
